// Admin Email Template
const getAdminEmailTemplate = ({ name, email, subject, message, mobile,product }) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f4f4f4;
        }
        .container {
          max-width: 600px;
          margin: 20px auto;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .header {
          background: linear-gradient(135deg, #2c541d 0%, #3d6b2a 100%);
          color: white;
          padding: 30px;
          text-align: center;
        }
        .header h1 {
          margin: 0;
          font-size: 24px;
          font-weight: 600;
        }
        .content {
          padding: 30px;
        }
        .info-box {
          background: #f8f9fa;
          border-left: 4px solid #2c541d;
          padding: 15px;
          margin: 15px 0;
          border-radius: 4px;
        }
        .info-label {
          font-weight: 600;
          color: #2c541d;
          margin-bottom: 5px;
        }
        .info-value {
          color: #555;
          word-wrap: break-word;
        }
        .message-box {
          background: #fff;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          padding: 20px;
          margin: 20px 0;
        }
        .footer {
          background: #f8f9fa;
          padding: 20px;
          text-align: center;
          font-size: 12px;
          color: #666;
        }
        .badge {
          display: inline-block;
          background: #2c541d;
          color: white;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 10px;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>🔔 New Contact Form Submission</h1>
          <p style="margin: 10px 0 0 0; opacity: 0.9;">Nirmita International</p>
        </div>

        <div class="content">
          <div class="badge">NEW INQUIRY</div>

          <div class="info-box">
            <div class="info-label">👤 Name</div>
            <div class="info-value">${name}</div>
          </div>

          <div class="info-box">
            <div class="info-label">📧 Email</div>
            <div class="info-value"><a href="mailto:${email}" style="color: #2c541d; text-decoration: none;">${email}</a></div>
          </div>

          <div class="info-box">
            <div class="info-label">📱 Mobile</div>
            <div class="info-value"><a href="tel:${mobile}" style="color: #2c541d; text-decoration: none;">${mobile}</a></div>
          </div>

          <div class="info-box">
            <div class="info-label">📝 Subject</div>
            <div class="info-value">${subject}</div>
          </div>

          <div class="info-box">
            <div class="info-label">Product Interested</div>
            <div class="info-value">${product}</div>
          </div>

          <div class="message-box">
            <div class="info-label" style="margin-bottom: 10px;">💬 Message</div>
            <div class="info-value" style="line-height: 1.8;">${message.replace(/\n/g, '<br>')}</div>
          </div>

          <div style="text-align: center; margin-top: 30px;">
            <a href="mailto:${email}" style="display: inline-block; background: #2c541d; color: white; padding: 12px 30px; text-decoration: none; border-radius: 5px; font-weight: 600;">Reply to Customer</a>
          </div>
        </div>

        <div class="footer">
          <p style="margin: 5px 0;">This email was sent from Nirmita International website contact form</p>
          <p style="margin: 5px 0;">Nirmita International | Pune, Maharashtra, India</p>
          <p style="margin: 10px 0 5px 0; font-size: 11px; color: #888;">Website developed by <strong>Swarajya Digital</strong></p>
        </div>
      </div>
    </body>
    </html>
  `;
};

// User Confirmation Email Template
const getUserConfirmationTemplate = ({ name }) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f4f4f4;
        }
        .container {
          max-width: 600px;
          margin: 20px auto;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .header {
          background: linear-gradient(135deg, #2c541d 0%, #3d6b2a 100%);
          color: white;
          padding: 40px 30px;
          text-align: center;
        }
        .header h1 {
          margin: 0 0 10px 0;
          font-size: 28px;
          font-weight: 600;
        }
        .content {
          padding: 40px 30px;
        }
        .success-icon {
          text-align: center;
          font-size: 60px;
          margin: 20px 0;
        }
        .message {
          text-align: center;
          font-size: 16px;
          color: #555;
          margin: 20px 0;
        }
        .info-box {
          background: #f0f7ed;
          border: 1px solid #d4edda;
          border-radius: 8px;
          padding: 20px;
          margin: 25px 0;
        }
        .cta-button {
          display: inline-block;
          background: #2c541d;
          color: white;
          padding: 14px 35px;
          text-decoration: none;
          border-radius: 5px;
          font-weight: 600;
          margin: 20px 0;
        }
        .footer {
          background: #f8f9fa;
          padding: 30px;
          text-align: center;
        }
        .social-links {
          margin: 20px 0;
        }
        .social-links a {
          display: inline-block;
          margin: 0 10px;
          color: #2c541d;
          text-decoration: none;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>✓ Message Received!</h1>
          <p style="margin: 0; opacity: 0.9;">Thank you for contacting us</p>
        </div>

        <div class="content">
          <div class="success-icon">✅</div>

          <h2 style="color: #2c541d; text-align: center;">Hello ${name}!</h2>

          <div class="message">
            <p>Thank you for reaching out to <strong>Nirmita International</strong>.</p>
            <p>We have successfully received your message and our team will review it shortly.</p>
          </div>

          <div class="info-box">
            <h3 style="color: #2c541d; margin-top: 0;">📋 What happens next?</h3>
            <ul style="color: #555; padding-left: 20px;">
              <li>Our team will review your inquiry within 24-48 hours</li>
              <li>You will receive a personalized response via email</li>
              <li>For urgent matters, feel free to call us at <strong>+91 9112474911</strong></li>
            </ul>
          </div>

          <div style="text-align: center;">
            <a href="https://nirmitainternational.com" class="cta-button">Visit Our Website</a>
          </div>
        </div>

        <div class="footer">
          <h3 style="color: #2c541d; margin-top: 0;">Get In Touch</h3>
          <p style="margin: 10px 0;">
            📧 <a href="mailto:info@nirmitainternational.com" style="color: #2c541d;">info@nirmitainternational.com</a><br>
            📱 <a href="tel:+919112474911" style="color: #2c541d;">+91 9112474911</a><br>
            📍 Plot No. 2, "Mangalya" Bungalow, Jagadish Society,<br>Dhankawdi, Pune-411043, Maharashtra, India
          </p>

          <div class="social-links">
            <a href="https://www.facebook.com/profile.php?id=61579068592688">Facebook</a> |
            <a href="https://www.instagram.com/nirmita_international/">Instagram</a> |
            <a href="https://www.linkedin.com/company/nirmita-international/">LinkedIn</a>
          </div>

          <p style="margin-top: 20px; font-size: 12px; color: #666;">
            This is an automated confirmation email. Please do not reply to this email.
          </p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendEmail = async ({ name, email, subject, message, mobile,product }) => {
  const payload = {
    smtpHost: "smtp.gmail.com",
    smtpPort: 587,
    smtpUser: 'infonirmita01@gmail.com',
    smtpPass: 'qooh swow liat drdi',
    from: "Nirmita International - Website Inquiry",
    to: "info@nirmitainternational.com",
    subject: `🔔 New Contact Form: ${subject} - ${name}`,
    text: `New message from ${name} (${email}):\n\n${message}\n\nMobile: ${mobile}`,
    html: getAdminEmailTemplate({ name, email, subject, message, mobile,product })
  };

  try {
    const response = await fetch("https://sendemail-3jje2wggzq-uc.a.run.app/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to send email");
    }

    return await response.json(); // success

    // USER CONFIRMATION EMAIL - COMMENTED OUT FOR NOW
    // Will be implemented later
    /*
    const userPayload = {
      smtpHost: "smtp.gmail.com",
      smtpPort: 587,
      smtpUser: 'infonirmita01@gmail.com',
      smtpPass: 'qooh swow liat drdi',
      from: "Nirmita International <info@nirmitainternational.com>",
      to: email,
      subject: "✓ We Received Your Message - Nirmita International",
      text: `Hello ${name},\n\nThank you for contacting Nirmita International...`,
      html: getUserConfirmationTemplate({ name })
    };

    const userResponse = await fetch("https://sendemail-3jje2wggzq-uc.a.run.app/sendEmail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userPayload)
    });
    */
  } catch (error) {
    throw error;
  }
};

// Quotation Admin Email Template
const getQuotationAdminTemplate = ({ name, email, mobile, productName }) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f4f4f4;
        }
        .container {
          max-width: 600px;
          margin: 20px auto;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .header {
          background: linear-gradient(135deg, #2c541d 0%, #3d6b2a 100%);
          color: white;
          padding: 30px;
          text-align: center;
        }
        .header h1 {
          margin: 0;
          font-size: 24px;
          font-weight: 600;
        }
        .content {
          padding: 30px;   
        }
        .info-box {
          background: #f8f9fa;
          border-left: 4px solid #2c541d;
          padding: 15px;
          margin: 15px 0;
          border-radius: 4px;
        }
        .info-label {
          font-weight: 600;
          color: #2c541d;
          margin-bottom: 5px;
        }
        .info-value {
          color: #555;
          word-wrap: break-word;
        }
        .product-box {
          background: #fff3cd;
          border: 2px solid #ffc107;
          border-radius: 8px;
          padding: 20px;
          margin: 20px 0;
          text-align: center;
        }
        .badge {
          display: inline-block;
          background: #ffc107;
          color: #000;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .footer {
          background: #f8f9fa;
          padding: 20px;
          text-align: center;
          font-size: 12px;
          color: #666;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>💰 New Quotation Request</h1>
          <p style="margin: 10px 0 0 0; opacity: 0.9;">Nirmita International</p>
        </div>

        <div class="content">
          <div class="badge">QUOTATION REQUEST</div>

          <div class="product-box">
            <h2 style="color: #2c541d; margin: 0 0 10px 0;">📦 ${productName}</h2>
            <p style="margin: 0; color: #666;">Customer is interested in this product</p>
          </div>

          <div class="info-box">
            <div class="info-label">👤 Customer Name</div>
            <div class="info-value">${name}</div>
          </div>

          <div class="info-box">
            <div class="info-label">📧 Email Address</div>
            <div class="info-value"><a href="mailto:${email}" style="color: #2c541d; text-decoration: none;">${email}</a></div>
          </div>

          <div class="info-box">
            <div class="info-label">📱 Mobile Number</div>
            <div class="info-value"><a href="tel:${mobile}" style="color: #2c541d; text-decoration: none;">${mobile}</a></div>
          </div>

          <div style="text-align: center; margin-top: 30px;">
            <a href="mailto:${email}" style="display: inline-block; background: #2c541d; color: white; padding: 12px 30px; text-decoration: none; border-radius: 5px; font-weight: 600;">Send Quotation</a>
          </div>
        </div>

        <div class="footer">
          <p style="margin: 5px 0;">This quotation request was sent from Nirmita International website</p>
          <p style="margin: 5px 0;">Nirmita International | Pune, Maharashtra, India</p>
          <p style="margin: 10px 0 5px 0; font-size: 11px; color: #888;">Website developed by <strong>Swarajya Digital</strong></p>
        </div>
      </div>
    </body>
    </html>
  `;
};

// Quotation User Confirmation Template
const getQuotationUserTemplate = ({ name, productName }) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        body {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          color: #333;
          margin: 0;
          padding: 0;
          background-color: #f4f4f4;
        }
        .container {
          max-width: 600px;
          margin: 20px auto;
          background: #ffffff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .header {
          background: linear-gradient(135deg, #2c541d 0%, #3d6b2a 100%);
          color: white;
          padding: 40px 30px;
          text-align: center;
        }
        .content {
          padding: 40px 30px;
        }
        .success-icon {
          text-align: center;
          font-size: 60px;
          margin: 20px 0;
        }
        .product-box {
          background: #f0f7ed;
          border: 1px solid #d4edda;
          border-radius: 8px;
          padding: 20px;
          margin: 25px 0;
          text-align: center;
        }
        .cta-button {
          display: inline-block;
          background: #2c541d;
          color: white;
          padding: 14px 35px;
          text-decoration: none;
          border-radius: 5px;
          font-weight: 600;
          margin: 20px 0;
        }
        .footer {
          background: #f8f9fa;
          padding: 30px;
          text-align: center;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>✓ Quotation Request Received!</h1>
          <p style="margin: 0; opacity: 0.9;">We'll send you the details soon</p>
        </div>

        <div class="content">
          <div class="success-icon">✅</div>

          <h2 style="color: #2c541d; text-align: center;">Hello ${name}!</h2>

          <p style="text-align: center; color: #555;">
            Thank you for your interest in our product. We have received your quotation request.
          </p>

          <div class="product-box">
            <h3 style="color: #2c541d; margin-top: 0;">📦 Requested Product</h3>
            <p style="font-size: 18px; font-weight: 600; color: #333; margin: 10px 0;">${productName}</p>
          </div>

          <div style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 8px; padding: 20px; margin: 25px 0;">
            <h3 style="color: #2c541d; margin-top: 0;">📋 Next Steps</h3>
            <ul style="color: #555; padding-left: 20px;">
              <li>Our sales team will prepare a detailed quotation</li>
              <li>You will receive the quotation via email within 24-48 hours</li>
              <li>For urgent requests, call us at <strong>+91 9112474911</strong></li>
            </ul>
          </div>

          <div style="text-align: center;">
            <a href="https://nirmitainternational.com" class="cta-button">Browse More Products</a>
          </div>
        </div>

        <div class="footer">
          <h3 style="color: #2c541d; margin-top: 0;">Contact Us</h3>
          <p style="margin: 10px 0;">
            📧 <a href="mailto:info@nirmitainternational.com" style="color: #2c541d;">info@nirmitainternational.com</a><br>
            📱 <a href="tel:+919112474911" style="color: #2c541d;">+91 9112474911</a>
          </p>

          <p style="margin-top: 20px; font-size: 12px; color: #666;">
            This is an automated confirmation email.
          </p>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendQuotationEmail = async ({ name, email, mobile, countryCode, productName }) => {
  const fullMobile = `${countryCode} ${mobile}`;
  const payload = {
    smtpHost: "smtp.gmail.com",
    smtpPort: 587,
    smtpUser: 'infonirmita01@gmail.com',
    smtpPass: 'qooh swow liat drdi',
    from: "Nirmita International - Quotation Request",
    to:"info@nirmitainternational.com",
    subject: `💰 New Quotation Request: ${productName} - ${name}`,
    text: `Quotation request from ${name} (${email}):\n\nMobile: ${fullMobile}\nProduct: ${productName}`,
    html: getQuotationAdminTemplate({ name, email, mobile: fullMobile, productName })
  };

  try {
    const response = await fetch("https://sendemail-3jje2wggzq-uc.a.run.app/sendEmail", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to send email");
    }

    return await response.json(); // success

    // USER CONFIRMATION EMAIL - COMMENTED OUT FOR NOW
    // Will be implemented later
    /*
    const userPayload = {
      smtpHost: "smtp.gmail.com",
      smtpPort: 587,
      smtpUser: 'infonirmita01@gmail.com',
      smtpPass: 'qooh swow liat drdi',
      from: "Nirmita International <info@nirmitainternational.com>",
      to: email,
      subject: "✓ Quotation Request Received - Nirmita International",
      text: `Hello ${name},\n\nWe have received your quotation request for ${productName}...`,
      html: getQuotationUserTemplate({ name, productName })
    };

    const userResponse = await fetch("https://sendemail-3jje2wggzq-uc.a.run.app/sendEmail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(userPayload)
    });
    */
  } catch (error) {
    throw error;
  }
};
